import Icon from "components/Icons/Icon";
import { useEffect, useState } from "react";
// import Placeholder1 from "../../img/profileplaceholders/profile-image-placeholder.svg";

type ProfilePictureProps = {
  image?: string;
  name?: string;
  className?: string;
};

const getInitials = (name?: string): string => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const ProfilePicture = ({ image, name, className }: ProfilePictureProps) => {
  const [imgError, setImgError] = useState(false);
  const [profileImage, setProfileImage] = useState("");

  useEffect(() => {
    if (profileImage !== image) {
      setProfileImage(image || "");
      setImgError(false);
    }
  }, [image]);

  const initials = getInitials(name);

  return (
    <div className={`profile-picture ${className || ""}`}>
      {profileImage && !imgError ? (
        <img src={profileImage} alt={name || ""} onError={() => setImgError(true)} />
      ) : initials ? (
        <div className="picture-placeholder initials-placeholder">{initials}</div>
      ) : (
        <div className="picture-placeholder user-profile-image-placeholder">
          <Icon name="user" />
        </div>
      )}
    </div>
  );
};

export default ProfilePicture;
